import { gql } from "@apollo/client";

export const ADMIN_LOGIN = gql`
  mutation adminLogin($id: String, $pw: String) {
    adminLogin(id: $id, pw: $pw)
  }
`;
